import { Check } from 'pcln-icons';
import React from 'react';
import styled from 'styled-components';
import { Button } from '../Button/Button';
import { Text } from '../Text/Text';
import { getPaletteColor } from '../utils/utils';
const StepButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "Step__StepButton",
  componentId: "sc-nwpntb-0"
})(["display:flex;background-color:", ";color:", ";cursor:", ";padding:0;font-weight:unset;&:hover{background-color:", ";}"], getPaletteColor('background.lightest'), getPaletteColor('base'), props => props.onClick ? 'pointer' : 'default', getPaletteColor('background.lightest'));
/**
 * @public
 */
export function Step({
  className = '',
  active = false,
  completed = false,
  children,
  onClick,
  ...props
}) {
  const color = active || completed ? 'primary' : 'text.light';
  return React.createElement(StepButton, {
    className: className,
    alignItems: 'center',
    onClick: onClick,
    mr: 4,
    ...props
  }, completed && React.createElement(Check, {
    color: 'primary',
    size: 16,
    mr: 1,
    "aria-hidden": false,
    "aria-label": 'Step Completed'
  }), React.createElement(Text, {
    color: color,
    bold: active,
    fontSize: 1,
    "aria-selected": active
  }, children));
}
Step.displayName = 'Step';